import { searchAPI } from '@/providers/apis/search/search';

export default({
    namespaced: true,
    state: {
        gooruContent: {},
        myContent: {},
      },
      getters: {

      },
      mutations: {
        fetachLearnerMyContent(state: any, payload: any) {
          state.myContent = payload;
        },

        fetachLearnerGooru(state: any, payload: any) {
          state.gooruContent = payload;
        },
      },
      actions: {
        fetachLearnerContent(context: any, params: any) {
          searchAPI.fetachLearnerContent('*', params).then((content) => {
            content.contents['offline-activity'] = content.contents.offlineActivity;
            context.commit('fetachLearnerMyContent', content.contents);
          });
        },

        fetachLearnerGooru(context: any) {
          searchAPI.fetachLearnerContent().then((content) => {
            content.contents['offline-activity'] = content.contents.offlineActivity;
            context.commit('fetachLearnerGooru', content.contents);
          });
        },
      },
});
